import { Component, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'data-explorer',
  standalone: false,
  templateUrl: './policy-explorer-main.component.html',
  styleUrls: ['./policy-explorer-main.component.css']
})
export class PolicyExplorerMainComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  clientId = '';
  schemaName = '';
  tableName = '';
  recordId = '';
  dataSetId?: string | null;

  routeReady = false;
  routeError?: string;

  constructor() {
    this.route.paramMap
      .pipe(
        map(params => ({
          clientId: (params.get('clientId') ?? '').trim(),
          schemaName: (params.get('schemaName') ?? '').trim(),
          tableName: (params.get('tableName') ?? '').trim(),
          recordId: (params.get('recordId') ?? '').trim()
        })),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: values => {
          this.clientId = values.clientId;
          this.schemaName = values.schemaName;
          this.tableName = values.tableName;
          this.recordId = values.recordId;
          this.validateRouteState();
        }
      });

    this.route.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: params => {
          const raw = params.get('dataSetId');
          this.dataSetId = raw && raw.trim().length > 0 ? raw.trim() : null;
          this.validateRouteState();
        }
      });
  }

  private validateRouteState(): void {
    const missing: string[] = [];
    if (!this.clientId) missing.push('clientId');
    if (!this.schemaName) missing.push('schemaName');
    if (!this.tableName) missing.push('tableName');
    if (!this.recordId) missing.push('recordId');

    if (missing.length > 0) {
      this.routeReady = false;
      this.routeError = `Missing required route parameter(s): ${missing.join(', ')}`;
      return;
    }

    this.routeReady = true;
    this.routeError = undefined;
  }
}
